import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Input.module.css";
/**
 * Input de texto do Azim CRM.
 * Gerencia foco visível via `:focus-within` no wrapper.
 * Use junto com `Field` para labels e mensagens de erro.
 */
export function Input({ icon, size = "md", rightEl, hasError = false, className, ...rest }) {
    const wrapperCls = [
        styles.wrapper,
        styles[size],
        hasError ? styles.wrapperError : "",
        className ?? "",
    ]
        .filter(Boolean)
        .join(" ");
    const inputCls = [styles.input, icon ? styles.inputWithIconLeft : ""]
        .filter(Boolean)
        .join(" ");
    return (_jsxs("div", { className: wrapperCls, children: [icon && (_jsx("span", { className: styles.iconLeft, "aria-hidden": "true", children: _jsx(Icon, { name: icon, size: 16 }) })), _jsx("input", { className: inputCls, ...rest }), rightEl && _jsx("span", { className: styles.rightAddon, children: rightEl })] }));
}
/**
 * Field — wrapper semântico com label, hint e mensagem de erro.
 * Associa label ao input via htmlFor/id.
 */
export function Field({ label, hint, error, required = false, htmlFor, children, className, }) {
    const errorId = htmlFor ? `${htmlFor}-error` : undefined;
    const hintId = htmlFor ? `${htmlFor}-hint` : undefined;
    return (_jsxs("div", { className: [styles.field, className ?? ""].filter(Boolean).join(" "), children: [label && (_jsxs("label", { htmlFor: htmlFor, className: styles.label, children: [label, required && (_jsxs("span", { className: styles.required, "aria-hidden": "true", children: [" ", "*"] })), required && _jsx("span", { className: "sr-only", children: "(obrigat\u00F3rio)" })] })), children, error ? (_jsx("span", { id: errorId, className: styles.error, role: "alert", children: error })) : hint ? (_jsx("span", { id: hintId, className: styles.hint, children: hint })) : null] }));
}
//# sourceMappingURL=Input.js.map